module.exports = __webpack_public_path__ + "img/course-publish-statistics.2d02b7f8.svg";